<template>
  <article class="pickup-ad-link-item-wrapper" @click="handleClick">
    <div class="image">
      <img :src="imageUrl" alt="ピックアップ広告画像" />
    </div>
    <div class="description">
      <p class="title-wrap">
        <ArticleTag v-if="tag && tagColor" :tag-color="tagColor" class="tag">{{ tag }}</ArticleTag
        ><span class="title">{{ title }}</span>
      </p>
      <p class="sponsor">{{ sponsorName }}</p>
    </div>
  </article>
</template>

<script>
import ArticleTag from '@v2/atoms/ArticleTag.vue';
import setGaTag from '@v2/plugins/google-analytics.js';

export default {
  name: 'PickupAdLinkItem',
  components: { ArticleTag },
  props: {
    /**
     * 画像URL
     */
    imageUrl: {
      type: String,
      required: true,
    },
    /**
     * スポンサー名
     */
    sponsorName: {
      type: String,
      required: true,
    },
    /**
     * ピックアップタイトル
     */
    title: {
      type: String,
      required: true,
    },
    /**
     * 記事URL
     */
    articleUrl: {
      type: String,
      required: true,
    },
    /**
     * タグテキスト
     */
    tag: {
      type: String,
      required: true,
    },
    /**
     * タグカラー
     */
    tagColor: {
      type: String,
      required: false,
      default: '',
    },
    /**
     * ピックアップ配信ID
     * NOTE: 病院側で表示する場合のみ渡される
     */
    deliveredPickupAdId: {
      type: Number,
      required: false,
      default: null,
    },
    /**
     * 既読フラグ
     * NOTE: 病院側で表示する場合のみ渡される
     */
    isRead: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    handleClick() {
      if (this.deliveredPickupAdId) {
        // GoogleAnalyticsタグ発火
        setGaTag({
          event: 'click',
          category: 'ピックアップ広告',
          label: this.title,
        });

        // 未読の場合は既読イベント発火
        if (!this.isRead) {
          this.$emit('read', this.deliveredPickupAdId);
        }
      }

      window.open(this.articleUrl, '_blank');
    },
  },
};
</script>

<style lang="sass" scoped>
.pickup-ad-link-item-wrapper
  display: grid
  grid-template-columns: 90px auto
  gap: 10px
  padding: 15px 0
  cursor: pointer
  img
    width: 100%
  p
    margin: 0
  .description
    .title-wrap
      font: $font-sub
      overflow: hidden
      display: -webkit-box
      -webkit-box-orient: vertical
      -webkit-line-clamp: 3
      .tag
        margin-right: 5px
      .title
        vertical-align: middle
    .sponsor
      font: $font-small
      color: $color-text-description
  &:hover
    .description
      .title
        text-decoration: underline
</style>
